//// Modo de uso
//// Paso 1: importar el archivo FormatoInput donde se desea utilizar
//// ej: import {formatoSeparadorMiles} from '../generico/utils/FormatoInput'
//// Paso 2: llamar al metodo formatoSeparadorMiles con el evento onkeyUp
//// Paso 3: incluir maxLength="19"
export const formatoSeparadorMiles = (e) => {

  //// formatea el valor ingresado
  const element = e.target;
  var value = element.value;

  value = String(value).replace(/\D/g, "");
  // element.value = value === "" ? value : Number(value).toLocaleString("es");
  element.value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

};

export const anhoActual = () => {
  var today = new Date();
  var year = today.getFullYear();
  return year + "";
};

/*
export const formatoSeparadorMilesReturn = (e) => {
  //// formatea el valor ingresado
  const element = e.target;
  var value = element.value;
  value = String(value).replace(/\./g, "");
  var arr = value.split(",");
  var retorno = 0;
  if (arr.length > 1) {
    if (arr[1] === "") {
      retorno = new Intl.NumberFormat("es-PY").format(parseFloat(arr[0]));
      retorno = retorno.toString();
      retorno += ",";
    } else {
      retorno = new Intl.NumberFormat("es-PY").format(parseFloat(arr[0] + "." + arr[1]));
    }
  } else {
    if (value != "") {
      retorno = new Intl.NumberFormat("es-PY").format(parseFloat(value));
    }
  }

  return retorno.toString();
};*/

export const formatoSeparadorMilesReturn = (e) => {
  //// formatea el valor ingresado  
  const element = e.target;
  var value = element.value;
  value = String(value).replace(/\./g, "");
  var arr = value.split(",");
  var retorno = 0;
  if (arr.length > 1) {
    if (arr[1] === "") {
      retorno = separadorMiles(value);
      retorno += ",";
    }
    else {
      //retorno = new Intl.NumberFormat("de-DE").format(parseFloat(arr[0] + "." + arr[1]));      
      var decimal = arr[1].substring(0, 2);
      retorno = separadorMiles(arr[0]) + "," + decimal;
    }
  }
  else {
    if (value !== "") {
      retorno = separadorMiles(value);
    }
  }

  return retorno.toString();
};

/** 
 * @author m_bareiro 
 * Nuevo separador de miles sin librería javascript 
 * @param input  
 * */
function separadorMiles(input) {
  var retorno = "";

  let num = input.replace(/\.|,|\s/g, '');
  // let num = input.replace(/,|\s/g, '');


  // var num = input.replace(/\./g, '');
  // num = num.replace(/\,/g, '');
  // num = input.replace(/\s/g, '');
  if (!isNaN(num)) {
    num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
    num = num.split('').reverse().join('').replace(/^[\.]/, '');
    retorno = num;
  }
  else {
    retorno = input.replace(/[^\d\.]*/g, '');
  }

  return retorno.toString();
}



export const formatoSeparadorMilesValue = (value) => {
  if (value === null)
    return 0;
  //console.log("Valor original antes de formatear " + value);
  value = String(value).replace(/[^0-9\-]/g, "");
  value = String(value).replace(/\,/g, ".");
  //console.log("Valor despues de remover la coma " + value);

  var arr = value.split(".");
  var retorno = 0;
  if (arr.length > 1) {
    if (arr[1] === "") {
      retorno = separadorMiles(value);
      //retorno += ",";
    }
    else {
      //retorno = new Intl.NumberFormat("de-DE").format(parseFloat(arr[0] + "." + arr[1]));      
      //var decimal = arr[1].substring(0, 2);
      retorno = separadorMiles(arr[0]) + "," + arr[1];
    }
  }
  else {
    if (value !== "") {
      retorno = separadorMiles(value);
    }
  }

  // var retorno = value === "" ? value : new Intl.NumberFormat("de-DE").format(parseFloat(value));
  //console.log("Valor despues de formatear " + retorno);
  return retorno;
};


export const formatoSeparadorMilesValueDollar = (value) => {
  if (value === null)
    return 0;
  //console.log("Valor original antes de formatear " + value);
  value = String(value).replace(/[^0-9]/g, ".");
  value = String(value).replace(/\,/g, "");
  //console.log("Valor despues de remover la coma " + value);

  var arr = value.split(".");
  var retorno = 0;
  if (arr.length > 1) {
    if (arr[1] === "") {
      retorno = separadorMiles(value);
      //retorno += ",";
    }
    else {
      //retorno = new Intl.NumberFormat("de-DE").format(parseFloat(arr[0] + "." + arr[1]));      
      //var decimal = arr[1].substring(0, 2);
      retorno = separadorMiles(arr[0]) + "," + arr[1];
    }
  }
  else {
    if (value !== "") {
      retorno = separadorMiles(value);
    }
  }

  // var retorno = value === "" ? value : new Intl.NumberFormat("de-DE").format(parseFloat(value));
  //console.log("Valor despues de formatear " + retorno);
  return retorno;
};


export const formatoSeparadorMilesValueExtracto = (value) => {
  if (value === null || value === undefined)
    return 0;
  //console.log("Valor original antes de formatear " + value);
  value = value.replace(/^0+/, '');
  value = String(value).replace(/\,/g, ".");
  //console.log("Valor despues de remover la coma " + value);

  var arr = value.split(".");
  var retorno = 0;
  if (arr.length > 1) {
    if (arr[1] === "") {
      retorno = separadorMiles(value);
      //retorno += ",";
    }
    else {
      //retorno = new Intl.NumberFormat("de-DE").format(parseFloat(arr[0] + "." + arr[1]));      
      //var decimal = arr[1].substring(0, 2);
      retorno = separadorMiles(arr[0]) + "," + arr[1];
    }
  }
  else {
    if (value !== "") {
      retorno = separadorMiles(value);
    }
  }

  // var retorno = value === "" ? value : new Intl.NumberFormat("de-DE").format(parseFloat(value));
  //console.log("Valor despues de formatear " + retorno);
  return retorno;
};


export const splitImporte = (importe) => {
  var _monto = "";
  if (importe === "0" || importe === 0) {
    _monto = "0";
  } else {
    _monto = String(importe).split(".").join("");
    _monto = String(_monto).replace(/\,/g, ".");
  }
  return _monto;
};
export const phoneNumberValido = (value) => {
  if (value[3] !== "6" && value[3] !== "7" && value[3] !== "8" && value[3] !== "9")
    return false;

  return true;
};

export const emailValido = (value) => {
  var regEx = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  var mail = value
  if (!regEx.test(mail)) {
    return false;
  }
  return true;
};
export const phoneFormatter = (value) => {
  var valor = String(value).replace("(", "");
  valor = String(valor).replace(")", "");
  valor = String(valor).replace("-", "");
  valor = String(valor).replace("_", "");
  return valor;
};
export const contieneMayuscula = (value) => {
  if (!/[A-Z]/.test(value))
    return false;
  return true;

};
export const contieneNumeros = (value) => {
  if (!/[0-9]/.test(value))
    return false;
  return true;

};

export const contieneCaracterEspecial = (value) => {
  var regularExpression = /^[a-zA-Z0-9!@#$%^&*]{6,16}$/;
  if (!regularExpression.test(value))
    return false;
  return true;
};


export const reemplazarBarra = (valor) => {
  var resultado = valor.replace("/", "");
  var original = resultado;

  var reemplazo = true;
  while (reemplazo) {
    resultado = resultado.replace("/", "");
    if (resultado === original)
      reemplazo = false
    else
      original = resultado

  }
  var fecha = original.substring(0, original.length - 4)
  fecha = fecha + original.substring(original.length - 2, original.length) + "000000"

  return fecha;
};

export const reemplazarPunto = (valor) => {
  var resultado = valor.replace(".", "");
  var original = resultado;
  var reemplazo = true;
  while (reemplazo) {
    resultado = resultado.replace(".", "");
    if (resultado === original)
      reemplazo = false
    else
      original = resultado

  }
  return resultado;
};

export const agregarBarra = (valor) => {

  if (valor === undefined || valor === null)
    return;
  var dia = valor.substring(0, 2)
  var mes = valor.substring(2, 4)
  var aa = valor.substring(4, 6)
  var fecha = dia + "/" + mes + "/20" + aa

  return fecha;
};

export const validarNull = (value) => {
  if (value === null || value === undefined) return "";
  return value;
};

export const dateFormat = (value) => {

  if (value == null) return null;

  value = new Date(value);

  let mes = (value.getMonth() + 1);
  mes = (mes < 10) ? "0" + mes : mes;

  value = value.getDate() + "/" + mes + "/" + value.getFullYear();

  return value;

}

export const completaCaracteres = (valor, caracter, tamanho) => {

  let tamanhoValor = valor.length;

  let cantFaltante = tamanho - tamanhoValor;

  let valorAux = "";

  while (cantFaltante > 0) {
    valorAux = valorAux + caracter;
    cantFaltante--;
  }

  valorAux = valorAux + valor;

  return valorAux;

}

export const mayusculaPrimeraLetra = (sentence = "") => {
  const palabra = sentence.toLowerCase().split(" ");
  palabra.forEach((el, i) => {
    palabra[i] = el.charAt(0).toUpperCase() + el.slice(1)
  })
  return palabra.join(" ")
}

export const normalizarMonto = (value) => {
  if (value === null || value === undefined) return "0";
  return String(value).replace(/[^0-9]/g, "");
};

export const separadorPuntoMiles = (monto = 0) => {
  let resultado = "";
  if (monto !== undefined) {
    resultado = monto.toString().replace(".", ",");
    resultado = resultado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  return resultado;
}